class FornivoGallery extends HTMLElement {
  #ac;
  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('command', event => {
      if (event.command !== '--show-image') return;
      const id = event.source?.dataset.mediaId;
      if (!id) return;
      for (const panel of this.querySelectorAll('[data-media-panel]')) panel.hidden = panel.dataset.mediaPanel !== id;
      for (const button of this.querySelectorAll('[data-media-id]')) button.setAttribute('aria-pressed', String(button.dataset.mediaId === id));
    }, {signal:this.#ac.signal});
  }
  disconnectedCallback() { this.#ac?.abort(); }
}
if (!customElements.get('fornivo-gallery')) customElements.define('fornivo-gallery',FornivoGallery);

